import styled from "styled-components";
import { FC, HTMLAttributes, useRef } from "react";

type Props = {
  src: string;
  alt: string;
};
const Headline: FC<HTMLAttributes<HTMLDivElement> & Props> = ({ src, alt, ...props }) => {
  const rootRef = useRef<HTMLDivElement>(null);
  return (
    <Root ref={rootRef} {...props}>
      <ImageTitle src={src} alt={alt} />
    </Root>
  );
};
export default Headline;

const Root = styled.div`
  display: flex;
  justify-content: center;

  @media screen and (max-width: 960px) {
    margin-bottom: 5vw;
  }
  @media screen and (min-width: 961px) {
    margin: 0 auto 50px;
    max-width: 800px;
  }
`;

const ImageTitle = styled.img`
  z-index: 2;
  
  @media screen and (max-width: 960px) {
    flex-shrink: 0;
    height: 10.5vw;
    max-height: 89px;
  }
  @media screen and (min-width: 961px) {
    height: 95px;
  }
  @media screen and (min-width: 1281px) {
    height: 105px;
  }
  @media screen and (min-width: 1501px) {
    height: 115px;
  }
`;
